import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

function addLinkOnce(attrs) {
  if (typeof document === "undefined") return;
  const href = attrs?.href;
  const rel = attrs?.rel;
  if (!href || !rel) return;

  const existing = document.querySelector(`link[rel="${rel}"][href="${href}"]`);
  if (existing) return;

  const link = document.createElement("link");
  Object.entries(attrs).forEach(([key, value]) => {
    if (value == null) return;
    if (key === "crossorigin") {
      link.setAttribute("crossorigin", String(value));
      return;
    }
    link.setAttribute(key, String(value));
  });
  document.head?.appendChild(link);
}

function normalizeHostToHttpsOrigin(hostOrOrigin) {
  if (!hostOrOrigin) return null;
  const raw = String(hostOrOrigin).trim();
  if (!raw) return null;

  // Accept either:
  // - "<account>.r2.cloudflarestorage.com"
  // - "https://<account>.r2.cloudflarestorage.com"
  // - "https://<account>.r2.cloudflarestorage.com/some/path"
  const withoutProtocol = raw.replace(/^https?:\/\//i, "");
  const host = withoutProtocol.split("/")[0]?.trim();
  if (!host) return null;

  return `https://${host}`;
}

// Warm up DNS/TCP/TLS to R2 before the first presigned image requests fire.
// Safe no-op unless configured via env.
(() => {
  const explicitHost = process.env.REACT_APP_R2_HOST;
  const accountId = process.env.REACT_APP_R2_ACCOUNT_ID;
  const derivedHost = accountId ? `${accountId}.r2.cloudflarestorage.com` : null;

  const origin = normalizeHostToHttpsOrigin(explicitHost || derivedHost);
  if (!origin) return;

  const host = origin.replace(/^https:\/\//i, "");
  addLinkOnce({ rel: "dns-prefetch", href: `//${host}` });
  addLinkOnce({ rel: "preconnect", href: origin, crossorigin: "anonymous" });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
